module.exports = __webpack_public_path__ + "img/group-text.dd41a2d3.svg";